export const HOMUNCULUS_OUTLINE_COLOR = '#122F4C';
export const HOMUNCULUS_DISABLED_COLOR = '#d1d1d6';
